// Date 2021-06-21 16:52:38

import emEntityListView from "@/components/em/EmEntity/ListView";
import emEntityEditView from "@/components/em/EmEntity/EditView";
import emWorkflowListView from "@/components/em/EmWorkflow/ListView";
import emWorkflowTaskView from "@/components/em/EmWorkflow/TaskView";
import emLevelTreeListView from "@/components/em/EmLevelTree/ListView";

import emOpcUaNodeInfoEouniList from "@/views/em/opcClient/EmOpcUaNodeInfoEouniList.vue";
import emOpcUaNodeInfoEouniEdit from "@/views/em/opcClient/EmOpcUaNodeInfoEouniEdit.vue";
import emOpcUaNodeSubscriptionEounsEdit from "@/views/em/opcClient/EmOpcUaNodeSubscriptionEounsEdit.vue";
import emOpcUaNodeSubscriptionEounsList from "@/views/em/opcClient/EmOpcUaNodeSubscriptionEounsList.vue";
import emOpcComputedEocEdit from "@/views/em/opcClient/EmOpcComputedEocEdit.vue";
import emOpcComputedEocList from "@/views/em/opcClient/EmOpcComputedEocList.vue";
import emOpcWatchEowList from "@/views/em/opcClient/EmOpcWatchEowList.vue";
import emOpcWatchEowEdit from "@/views/em/opcClient/EmOpcWatchEowEdit.vue";
import emOpcWatchConditionEowcList from "@/views/em/opcClient/EmOpcWatchConditionEowcList.vue";
import emOpcWatchConditionEowcEdit from "@/views/em/opcClient/EmOpcWatchConditionEowcEdit.vue";
import emOpcComputedActionEocaList from "@/views/em/opcClient/EmOpcComputedActionEocaList.vue";
import emOpcComputedActionEocaEdit from "@/views/em/opcClient/EmOpcComputedActionEocaEdit.vue";
import emOpcComputedEventEoceList from "@/views/em/opcClient/EmOpcComputedEventEoceList.vue";
import emOpcComputedEventEoceEdit from "@/views/em/opcClient/EmOpcComputedEventEoceEdit.vue";
const metaObject = {requiresAuth: true, roles: ['mmf']};

export default [
//公用组件注册
    {
        path: "/em/opcClient/emOpcUaPublishRecordEoupr/list",
        name: "emOpcUaPublishRecordEouprList",
        component: emEntityListView,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/em/opcClient/emOpcUaPublishRecordEoupr/edit",
        name: "emOpcUaPublishRecordEouprEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/opcClient/emOpcComputedTypeEoct/list",
        name: "emOpcComputedTypeEoctList",
        component: emEntityListView,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/em/opcClient/emOpcComputedTypeEoct/edit",
        name: "emOpcComputedTypeEoctEdit",
        component: emEntityEditView,
        meta: metaObject
    },
//自定义页面注册
    {
        path: "/em/opcClient/emOpcUaNodeInfoEouniList",
        name: "emOpcUaNodeInfoEouniList",
        component: emOpcUaNodeInfoEouniList,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/em/opcClient/emOpcUaNodeInfoEouniEdit",
        name: "emOpcUaNodeInfoEouniEdit",
        component: emOpcUaNodeInfoEouniEdit,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/em/opcClient/emOpcUaNodeSubscriptionEounsEdit",
        name: "emOpcUaNodeSubscriptionEounsEdit",
        component: emOpcUaNodeSubscriptionEounsEdit,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/em/opcClient/emOpcUaNodeSubscriptionEounsList",
        name: "emOpcUaNodeSubscriptionEounsList",
        component: emOpcUaNodeSubscriptionEounsList,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/em/opcClient/emOpcComputedEocEdit",
        name: "emOpcComputedEocEdit",
        component: emOpcComputedEocEdit,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/em/opcClient/emOpcComputedEocList",
        name: "emOpcComputedEocList",
        component: emOpcComputedEocList,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/em/opcClient/emOpcWatchEowList",
        name: "emOpcWatchEowList",
        component: emOpcWatchEowList,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/em/opcClient/emOpcWatchEowEdit",
        name: "emOpcWatchEowEdit",
        component: emOpcWatchEowEdit,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/em/opcClient/emOpcWatchConditionEowcList",
        name: "emOpcWatchConditionEowcList",
        component: emOpcWatchConditionEowcList,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/em/opcClient/emOpcWatchConditionEowcEdit",
        name: "emOpcWatchConditionEowcEdit",
        component: emOpcWatchConditionEowcEdit,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/em/opcClient/emOpcComputedActionEocaList",
        name: "emOpcComputedActionEocaList",
        component: emOpcComputedActionEocaList,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/em/opcClient/emOpcComputedActionEocaEdit",
        name: "emOpcComputedActionEocaEdit",
        component: emOpcComputedActionEocaEdit,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/em/opcClient/emOpcComputedEventEoceList",
        name: "emOpcComputedEventEoceList",
        component: emOpcComputedEventEoceList,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/em/opcClient/emOpcComputedEventEoceEdit",
        name: "emOpcComputedEventEoceEdit",
        component: emOpcComputedEventEoceEdit,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    }
]